// utils/cronOptions.js
export const SERVICES = [
  { id: "user-report", title: "User Report", description: "Generates a report of all registered users" },
  { id: "revenue-report", title: "Revenue Report", description: "Generates a revenue summary" },
  { id: "summary-report", title: "Summary Report", description: "Generates a monthly business summary" },
];

export const INTERVALS = [
  { id: "1m", label: "Every 1 minute", expression: "* * * * *" },
  { id: "5m", label: "Every 5 minutes", expression: "*/5 * * * *" },
  { id: "15m", label: "Every 15 minutes", expression: "*/15 * * * *" },
  { id: "30m", label: "Every 30 minutes", expression: "*/30 * * * *" },
  { id: "60m", label: "Every 60 minutes", expression: "0 * * * *" },
  { id: "3h", label: "Every 3 hours", expression: "0 */3 * * *" },
  { id: "6h", label: "Every 6 hours", expression: "0 */6 * * *" },
  { id: "12h", label: "Every 12 hours", expression: "0 */12 * * *" },
  { id: "1d", label: "Every 1 day", expression: "0 0 * * *" },
  { id: "7d", label: "Every 7 days", expression: "0 0 */7 * *" },
  { id: "30d", label: "Every 30 days", expression: "0 0 */30 * *" },
  { id: "3M", label: "Every 3 months", expression: "0 0 1 */3 *" },
  { id: "6M", label: "Every 6 months", expression: "0 0 1 */6 *" },
  { id: "1Y", label: "Every 1 year", expression: "0 0 1 1 *" },
];